module.exports = __webpack_public_path__ + "img/5.626542b7.jpg";